import {Fragment} from "react";
import {Timeline, Table, Empty} from "antd";
import Image from "~/components/Image";
import StatusLabel from "~/components/StatusLabel";
import Loading from "~/components/Loading";
import Icon from "~/components/Icon";

/**
 * Hiển thị lịch sử thao tác dạng timeline (nhóm theo ngày).
 *
 * Dữ liệu `histories` mong đợi:
 * [
 *   {
 *     date: "06-06-2026",
 *     list: [
 *       {
 *         id, hour, action, actionLabel, badge, note,
 *         user: { id, firstname, lastname, avatar } | null,
 *         changes: [ { label, old, new }, ... ]
 *       }
 *     ]
 *   }
 * ]
 */
function HistoryTimeline({histories = [], loading = false, emptyText = 'Chưa có lịch sử thao tác nào'}) {

	const changeColumns = [
		{title: 'Thông tin', dataIndex: 'label', width: '34%', render: (v) => <b>{v}</b>},
		{title: 'Trước', dataIndex: 'old', width: '33%', render: (v) => <span style={{color: '#cf1322'}}>{v === '' || v === null || v === undefined ? '—' : v}</span>},
		{title: 'Sau', dataIndex: 'new', width: '33%', render: (v) => <span style={{color: '#389e0d'}}>{v === '' || v === null || v === undefined ? '—' : v}</span>},
	];

	const renderUser = (user) => {
		if (!user) return <b>Hệ thống</b>;
		return (
			<span style={{display: 'inline-flex', alignItems: 'center', gap: 6, verticalAlign: 'middle'}}>
				{user.avatar && <span style={{width: 24, height: 24, borderRadius: '50%', overflow: 'hidden', display: 'inline-block'}}><Image src={user.avatar}/></span>}
				<b>{`${user.firstname || ''} ${user.lastname || ''}`.trim() || 'Không xác định'}</b>
			</span>
		);
	};

	if (loading) return <Loading/>;

	if (!histories || histories.length === 0) {
		return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText}/>;
	}

	return (
		<Timeline>
			{histories.map((timeLine) => (
				<Fragment key={`history-${timeLine.date}`}>
					<Timeline.Item dot={Icon.hourglass} color="red"><b>{timeLine.date}</b></Timeline.Item>
					{timeLine.list.map((line) => (
						<Timeline.Item key={`history-item-${line.id}`}>
							<div className="d-flex gap align-items" style={{flexWrap: 'wrap'}}>
								{renderUser(line.user)}
								<StatusLabel small type={line.badge || 'default'}>{line.actionLabel}</StatusLabel>
								<span style={{color: '#999'}}>lúc <b>{line.hour}</b></span>
							</div>
							{line.note && <p style={{margin: '6px 0', color: '#555'}}>{line.note}</p>}
							{Array.isArray(line.changes) && line.changes.length > 0 && (
								<Table
									className="mt-1"
									rowKey={(r, i) => `${line.id}-${i}`}
									size="small"
									columns={changeColumns}
									dataSource={line.changes}
									pagination={false}
								/>
							)}
						</Timeline.Item>
					))}
				</Fragment>
			))}
		</Timeline>
	);
}

export default HistoryTimeline;
